import PropTypes from 'prop-types';
import React, { useRef } from 'react';

const HorizontalScrollContainer = ({ children, style = {} }) => {
  const scrollRef = useRef(null);

  const onWheel = (e) => {
    if (scrollRef.current) {
      // Scroll horizontally
      scrollRef.current.scrollLeft += e.deltaY;
    }
  };

  return (
    <div
      ref={scrollRef}
      onWheel={onWheel}
      style={{
        overflowX: 'auto',
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: '100%',
        gap: '1.25rem',
        padding: '1.5rem',
        ...style,
      }}
    >
      {children}
    </div>
  );
};

HorizontalScrollContainer.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
};

export default HorizontalScrollContainer;
